<template>
  <tk-container class="about">
    <tkui-header center slot="header">
      <tk-icon @click.native="back" slot="left-menu">Return</tk-icon>
      关于我们
    </tkui-header>
    <div class="body">
      <h1 class="tit">电磁开水器智能管理平台</h1>
      <p class="des text">{{description}}</p>
      <!--<p class="text tel" v-if="tel">公司电话：{{tel}}</p>-->
      <!--<p class="text address" v-if="address">地　　址：{{address}}</p>-->
      <div class="noticeBox">
        <!--<p class="notice" v-if="icp">Copyright©2017-2037</p>-->
        <!--<p class="notice" v-if="company">{{company}}</p>-->
      </div>
    </div>
  </tk-container>
</template>

<script>
  export default {
    data () {
      return {
        description: '',
        company: '',
        tel: '',
        address: '',
        icp: ''
      }
    },
    async created () {
      let res = await this.$tkParse.getData('/config')
      this.description = res.params.about || ''
      this.company = res.params.company || ''
      this.tel = res.params.phone || ''
      this.address = res.params.address || ''
      this.icp = res.params.ICP || ''
    },
    methods: {
      back () {
        this.$back()
      }
    }
  }
</script>

<style scoped lang="scss" rel="stylesheet/scss">
  .about{
    background: #ffffff;
    .body{
      padding: 0 15px;
      .tit{
        text-align: center;
        font-size: 24px;
        color: #0091FF;
        padding: 30px 0;
        letter-spacing: 2px;
      }
      .text{
        color: #233038;
        font-size: 16px;
        line-height: 26px;
      }
      .des{
        text-indent: 32px;
        margin-bottom: 30px;
        letter-spacing: 1px;
      }
      .tel{
        margin-bottom: 25px;
      }
      .address{
        margin-bottom: 100px;
      }
      .noticeBox{
        text-align: center;
        font-size: 12px;
        color: #999999;
        .notice{
          margin-bottom: 10px;
        }
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/page/app/user/aoubtUs.vue